// filepath: /Users/a1111/WebstormProjects/arch-editor/src/components/Header.js
import React from 'react';
import { useTheme } from '../hooks/useTheme';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const Header = ({ title = 'Aspect', username = undefined, height = 56, controls = null }) => {
  const { theme } = useTheme();
  const navigate = useNavigate();
  const { user } = useAuth();
  const displayUsername = username || user?.displayName || user?.username || 'guest';

  return (
    <div
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        height,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        padding: '0 16px',
        background: theme.toolbar.background,
        color: theme.toolbar.text,
        borderBottom: `1px solid ${theme.toolbar.border}`,
        boxShadow: theme.toolbar.shadow,
        zIndex: 3000
      }}
    >
      <div
        onClick={() => navigate('/')}
        title="На главную"
        style={{ display: 'inline-flex', alignItems: 'center', gap: 10, fontWeight: 700, letterSpacing: 0.5, cursor: 'pointer', userSelect: 'none' }}
      >
        {title}
      </div>
      <div style={{ display: 'flex', alignItems: 'center', gap: 8, minHeight: '100%' }}>
        {controls}
      </div>
      <div style={{ display: 'flex', alignItems: 'center', gap: 16 }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 8, cursor: 'pointer' }} onClick={() => navigate('/profile')}>
          <AccountCircleIcon style={{ width: 22, height: 22, color: theme.toolbar.text }} />
          <span style={{ fontSize: 14, color: theme.toolbar.text, opacity: 0.9 }}>{displayUsername}</span>
        </div>
      </div>
    </div>
  );
};

export default Header;
